document.addEventListener('DOMContentLoaded', function() {
    // Attach the submit event listener to the document or a parent element
    document.getElementById('globalModal').addEventListener('submit', function(event) {
        // Check if the target form is the mortgageCalculator form
        if (event.target && event.target.id === 'mortgageCalculator') {
            event.preventDefault();

            // Get input values
            const totalAmount = parseFloat(document.getElementById('totalAmount').value);
            const downPayment = parseFloat(document.getElementById('downPayment').value);
            const interestRate = parseFloat(document.getElementById('interestRate').value) / 100;
            const amortizationPeriod = parseInt(document.getElementById('amortizationPeriod').value);
            const paymentPeriod = parseInt(document.getElementById('paymentPeriod').value);

            // Calculate principal
            const loanAmount = totalAmount - downPayment;

            // Calculate monthly interest rate
            const monthlyInterestRate = interestRate / paymentPeriod;

            // Calculate total number of payments
            const totalPayments = amortizationPeriod * paymentPeriod;

            // Calculate payment
            const payment = loanAmount * 
                (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, totalPayments)) / 
                (Math.pow(1 + monthlyInterestRate, totalPayments) - 1);

            // Display results
            const resultsDiv = document.getElementById('calculatorResults');
            if (!isNaN(payment)) {
                resultsDiv.innerHTML = `
                    <h5>Results:</h5>
                    <p>Total Loan Amount: $${loanAmount.toFixed(2)}</p>
                    <p>Your Payment: $${payment.toFixed(2)} (${paymentPeriod === 12 ? 'Monthly' : paymentPeriod === 26 ? 'Bi-Weekly' : 'Weekly'})</p>
                `;
            } else {
                resultsDiv.innerHTML = '<p class="text-danger">Invalid input. Please check your values.</p>';
            }
        }
    });
});
